import Layout from '../../../layout/Layout'
import PatternCreate from 'components/organisms/PatternCreate/PatternCreate'
import HeaderPageSection from 'core/presentation/components/molecules/HeaderPageSection/HeaderPageSection'

export default function CreateTemplatePage() {
    const breadcrumbNavigate = [
        {
            label: 'Plantillas',
            path: '/templates',
        },
        {
            label: 'Crear Plantilla',
            path: '/templates/create',
        },
    ]

    return (
        <Layout>
            <HeaderPageSection
                title="Crear nueva plantilla"
                showGoBack={false}
                breadcrumbItems={breadcrumbNavigate}
            />
            <PatternCreate />
        </Layout>
    )
}
